/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Mixins
import chart from './chart';

// Components
import DoubleStat from 'shared/ui/components/cards/DoubleStat.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';

const __vue_script__ = {
    name: 'Registrations',

    components: { DoubleStat, ExpandableContent },

    mixins: [chart],

    props: {
        accentStyle: {
            type: Function,
            required: true
        },

        description: {
            type: Function,
            required: true
        }
    },

    data() {
        return {
            data: {},
            visibleMetrics: []
        };
    },

    computed: {
        visibleDescriptions() {
            const descriptions = new Set();
            for (const metric of this.visibleMetrics) {
                descriptions.add(this.description(metric));
            }
            return descriptions;
        }
    },

    methods: {
        /**
         * This override the mixin method.
         * @override
         */
        async loadChartData() {
            try {
                this.loading = true;
                this.data = await this.$services.analytics.loadRegistrationStats(this.eventId);

                const receivedKeys = Object.keys(this.data);
                // This is because we want to maintain the
                // order of the keys defined in charts.js
                this.visibleMetrics = this.metrics.filter(m => receivedKeys.includes(m));
            } catch (error) {
                console.error('[Registrations] Could not load chart data', error.message);

            } finally {
                this.loading = false;
            }
        },

        getTitle(metric) {
            return this.$t(`analytics.metrics.${metric}.title`);
        },

        getStatA(metric) {
            return get(this.data, `${metric}.current`, 0);
        },

        getStatB(metric) {
            if (this.hasStatB(metric)) {
                return this.data[metric].today;
            }
            return null;
        },

        getFooterStats(metric) {
            /** @type {{ label: string, stat: string|number }[]} */
            const footerStats = [];

            if (Number.isFinite(get(this.data, `${metric}.total`))) {
                const value = get(this.data, `${metric}.total`);
                footerStats.push({
                    stat: this.$utils.numbers.percentage(value, this.getStatA(metric)),
                    label: this.$t(`analytics.metrics.${metric}.total`),
                });
            }

            if (Number.isFinite(get(this.data, `${metric}.limits`))) {
                const value = get(this.data, `${metric}.current`);
                footerStats.push({
                    stat: this.$utils.numbers.percentage(get(this.data, `${metric}.limits`), value),
                    label: this.$t(`analytics.metrics.${metric}.limits`),
                });
            }

            return footerStats;
        },

        getSub(metric) {
            const tKey = `analytics.metrics.${metric}.sub`;
            return this.$te(tKey) ? this.$t(tKey) : null;
        },

        hasStatB(metric) {
            return this.data.hasOwnProperty(metric) && this.data[metric].hasOwnProperty('today');
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registrations chart-widget"},[_c('div',{staticClass:"title"},[(_vm.icon)?_c('i',{class:("ic-" + _vm.icon)}):_vm._e(),_vm._v(_vm._s(_vm.$t(("analytics.charts." + _vm.name + ".title"))))]),(_vm.loading)?_c('loader',{staticClass:"static",attrs:{"status":_vm.loading}}):[_c('div',{ref:"chart",staticClass:"chart"},_vm._l((_vm.visibleMetrics),function(metric){return _c('double-stat',{key:metric,attrs:{"title":_vm.getTitle(metric),"metric":metric,"stat-a":_vm.getStatA(metric),"label-a":_vm.$t('analytics.charts.registrations.total'),"stat-b":_vm.getStatB(metric),"label-b":_vm.$t('analytics.charts.registrations.today'),"footer-stats":_vm.getFooterStats(metric),"sub":_vm.getSub(metric),"color":_vm.lineColor(metric),"badge-class":_vm.accentStyle(metric)}})}),1),_c('div',{staticClass:"details"},[_c('expandable-content',{staticClass:"metrics",attrs:{"show-toggler":false,"clickable-header":true,"slim":true},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var open = ref.open;
return [_c('h4',{class:{ open: open }},[_vm._v(_vm._s(_vm.$t('analytics.metrics.more'))),_c('i',{staticClass:"ic-chevron-down"})])]}}])},_vm._l((_vm.visibleDescriptions),function(metric){return _c('div',{staticClass:"metric"},[_c('div',{staticClass:"name"},[_c('span',{staticClass:"color",style:({ 'background-color': _vm.lineColor(metric) })}),_vm._v(_vm._s(_vm.$t(("analytics.metrics." + metric + ".title"))))]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.$t(("analytics.metrics." + metric + ".description"))))])])}),0)],1)]],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Registrations.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__